export { default as theme } from 'prismjs/themes/prism-twilight.css';
